import React from 'react'
import cx from 'classnames'
import { Field as FormField } from 'redux-form'
import { uniqid } from 'webmango-utils'
import debounce from 'lodash/debounce'

import './Form.css'

export class Field extends React.PureComponent {
  render () {
    return <FormField {...this.props} component={FieldRenderer} />
  }
}

export {
  uniqid as getUID
}

export class FieldRenderer extends React.Component {
  componentWillMount () {
    this.uid = this.props.uid || uniqid()
  }

  render () {
    const { props } = this
    const { input, list, spellCheck, disabled, autoComplete, autoFocus, children, label, type, append, meta } = props
    const placeholder = props.placeholder != null ? props.placeholder : label
    return (
      <FormItem uid={this.uid} {...props} disabled={!!disabled} error={meta.error} warning={meta.warning}>
        {
          type === 'select'
            ? <Select id={this.uid} disabled={!!disabled} readOnly={React.Children.count(children) <= 1} {...input}>{children}</Select>
            : (
              <Input
                key={autoFocus}
                id={this.uid}
                placeholder={placeholder}
                type={type}
                list={list}
                disabled={!!disabled}
                autoComplete={autoComplete}
                autoFocus={autoFocus}
                spellCheck={spellCheck}
                {...input}
              />
            )
        }
        {typeof append === 'function' ? append() : append}
        <FormItemMessages {...props} />
      </FormItem>
    )
  }
}

export function FormItem (props) {
  const { className, error, warning, disabled, label, children, uid } = props
  return (
    <div className={cx('FormItem', className, { error: !!error, warning: !!warning, disabled: !!disabled })}>
      <label htmlFor={uid}>{label}</label>
      <span className='inputContainer'>
        {children}
      </span>
    </div>
  )
}

export function FormItemMessages (props) {
  const { meta: { touched, error, warning } } = props
  return (
    <div className='messages'>
      {(!props.validateOnBlur || touched) && (
        (!error && !warning && <span className='message success' />) ||
        (error && <div className='message error'>{error}</div>) ||
        (warning && <div className='message warning'>{warning}</div>)
      )}
    </div>
  )
}

export function required (value) {
  if (typeof value === 'string') value = value.trim()
  return trim(value) ? undefined : 'Required.'
}

export function unique (values = []) {
  return value => {
    return values.indexOf(trim(value)) === -1 ? undefined : 'Must be unique.'
  }
}

export function trim (value) {
  return typeof value === 'string' ? value.trim() : value
}

export function trimLeft (value) {
  return typeof value === 'string' ? value.trimLeft() : value
}

export function Select (props) {
  return (
    <div className={cx('Select', { readOnly: props.readOnly })}>
      <select {...props} />
    </div>
  )
}

export class Input extends React.PureComponent {
  static defaultProps = {
    timeout: 200
  }

  state = { value: this.props.value }
  lastPropValue = this.props.value
  debouncedOnChange = debounce(event => {
    this.props.onChange(event)
  }, this.props.timeout)

  handleChange = event => {
    event.persist()
    if (this.props.type === 'checkbox') {
      // do nothing special for checkboxes
      return this.props.onChange(event.target.checked)
    }
    const { value } = event.target
    this.setState({ value })
    this.debouncedOnChange(event)
  }

  static getDerivedStateFromProps (props, state) {
    if (state.hasFocus) {
      return null
    } else {
      return { value: props.value }
    }
  }

  onFocus = (event) => {
    this.setState({ hasFocus: true })
    this.props.onFocus && this.props.onFocus(event)
  }

  onBlur = (event) => {
    this.setState({ hasFocus: false })
    this.props.onBlur && this.props.onBlur(event)
  }

  getValue () {
    if (this.props.type === 'checkbox') return this.props.value
    const value = this.props.value !== this.lastPropValue
      ? this.props.value
      : this.state.value

    this.lastPropValue = this.props.value

    return value
  }

  render () {
    const { timeout, ...props } = this.props
    return (
      props.type === 'textarea' ? (
        <textarea
          {...props}
          value={this.getValue()}
          onChange={this.handleChange}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
        />
      ) : (
        <input
          {...props}
          value={this.getValue()}
          onChange={this.handleChange}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
        />
      )
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Form.js